module.exports = __webpack_public_path__ + "img/th.d1fca9e7.png";